import React from "react";
import './meet.css';

const Meet = () => {
    return (
        <div className="meet container section" id="meet">
            <h2 className="section__title">Wanna Meet</h2>
            <span className="section__subtitle">Let's have a Quick call</span>

            <div className="meet__container">
                <h3 className="meet__title">Choose the date and time, <br /> and i'll be there.</h3>
                <a href="https://calendly.com/hmesrar48/30min" target="_blank" rel="noreferrer" className="button button--flex button--white">
                    Book from here <i className="uil uil-calendar-alt button__icon"></i>
                </a>
            </div>
        </div>
    );
}

export default Meet;